import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=53539b00&scoped=true"
import script from "./Logos.vue?vue&type=script&lang=ts"
export * from "./Logos.vue?vue&type=script&lang=ts"
import style0 from "./Logos.vue?vue&type=style&index=0&id=53539b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53539b00",
  null
  
)

export default component.exports